import React, { useEffect } from 'react';
import framework from 'utils/framework';
import cookieUtils from 'utils/Cookies';
import urlUtils from 'utils/Url';
const { wrapHOC, wrapHOCComponent } = framework;

const withCookie = wrapHOC(function withCookie(WrappedComponent, cookieName, cookieValue, redirectUrl) {
    const CookieGate = props => {
        useEffect(() => {
            const currentCookieValue = cookieUtils.read(cookieName);
            const cookieMatches = currentCookieValue === cookieValue;

            if (!cookieMatches) {
                urlUtils.redirectTo(redirectUrl);
            }
        }, []);

        return <WrappedComponent {...props} />;
    };

    return wrapHOCComponent(CookieGate, 'CookieGate', arguments);
});

export { withCookie };
